import { get, post, remove } from '../../services/request';

export async function userGeneralInfo() {
    const response = await get('/ui/user/general');
    return response;
}

export async function updateGeneralInfo(
    firstName,
    lastName,
    phoneCountryCode,
    phone,
    language,
    locale,
    timezone,
) {
    const response = await post('/ui/user/general', {
        firstName,
        lastName,
        phone,
        phoneCountryCode,
        language,
        locale,
        timezone,
    });
    return response;
}

export async function userEmailsInfo() {
    const response = await get('/ui/user/emails');
    return response;
}

export async function makeSecondaryEmailPrimary(password) {
    const response = await post('/ui/user/emails/swap-primary-with-secondary', {
        password,
    });
    return response;
}

export async function sendEmailVerification() {
    const response = await post('/ui/user/emails/secondary/send-verification');
    return response;
}

export async function removeSecondaryEmail(password) {
    const response = await remove('/ui/user/emails/secondary', {
        password,
    });
    return response;
}

export async function addSecondaryEmail(password, email) {
    const response = await post('/ui/user/emails/secondary', {
        password,
        email,
    });
    return response;
}

/**
 * Resets password in MyAccount
 * @param {string} oldPassword
 * @param {string} newPassword
 */
export async function changePassword(oldPassword, newPassword) {
    const response = await post('/ui/user/change-password', {
        oldPassword,
        newPassword,
    });
    return response;
}

export function requestEmailUpdate(email, recaptchaToken) {
    return post('/ui/username/request-update', {
        email,
        recaptchaToken,
    });
}
